/* ==============================================================================================
 * DATA CHALLENGE COMPONENT
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
    "use strict";

    /** Opens data challenge section */
    var open = function (target) {
        target.classList.add("is-open");
    };

    /** Closes data challenge section */
    var close = function (target) {
        target.classList.add("is-closing");

        setTimeout(function () {
            target.classList.remove("is-closing");
            target.classList.remove("is-open");
        }, 300);
    };

    /** Get trigger buttons */
    var getTriggerButtons = function (element) {
        return element.querySelectorAll("[data-challenge]");
    };

    /** Get target */
    var getTarget = function (trigger) {
        return document.querySelector(trigger.getAttribute("data-challenge-target"));
    };

    /** Get target */
    var getCloseButtons = function (element) {
        return element.querySelectorAll("[data-close]");
    };

	var createInstances = function (parentElement) {
		var dataChallengeButtons = getTriggerButtons(parentElement);

		Sushi.Dom.forEach(dataChallengeButtons, function (button) {
            var target = getTarget(button);
            var closeButtons = getCloseButtons(target);

            // Form submission
            Sushi.Events(target).on("submit", function (event) {
                event.preventDefault();

                // TODO: handle data challenge form submission
                console.log("Submit data challenge");
            });

            Sushi.Events(button).on("click", function () {
                open(target);
            });

            Sushi.Events(closeButtons).on("click", function () {
                close(target);
            });
		});
    };

    var destroyInstances = function (parentElement) {
        var dataChallengeButtons = getTriggerButtons(parentElement);

		Sushi.Dom.forEach(dataChallengeButtons, function (button) {
            var target = getTarget(button);
            var closeButtons = getCloseButtons(target);

            Sushi.Events(button).off("click");
            Sushi.Events(closeButtons).off("click");

            close(target);
		});
    };

	/* Data challenge modal
	 * --------------------------- */

	Sushi.Events(document).on("Modal.open", function (event) {
		createInstances(event.target);
    });

    Sushi.Events(document).on("Modal.closed", function (event) {
		destroyInstances(event.target);
	});

})(Sushi || (Sushi = {}));
